import React from 'react';

import './bv-shimmer.scss';

import BVShimmerCard from '../BVShimmerCard/bv-shimmer-card';
import BVShimmerDetails from '../BVShimmerDetails/bv-shimmer-details';
import BVShimmerGroup from '../BVShimmerGroup/bv-shimmer-group';
import BVShimmerImage from '../BVShimmerImage/bv-shimmer-image';
import BVShimmerNav from '../BVShimmerNav/bv-shimmer-nav';
import BVShimmerPrice from '../BVShimmerPrice/bv-shimmer-price';
import BVShimmerType from '../BVShimmerType/bv-shimmer-type';
import BVShimmerOneLine from '../BVShimmerOneLine/bv-shimmer-oneline';

interface IBVShimmer {
    loading: boolean;
    type?: 'shimmer-card' | 'shimmer-group' | 'shimmer-image' | 'shimmer-nav' | 'shimmer-price' | 'shimmer-type' | 'shimmer-details' | 'shimmer-oneline';
    style?: any;
}

const BVShimmer: React.FunctionComponent<IBVShimmer> = ({ loading, type, style, children }) => {
    const _handleShimmer = () => {
        switch (type) {
            case 'shimmer-card': {
                return (
                    <BVShimmerCard style={style} />
                );
            }
            case 'shimmer-details': {
                return (
                    <BVShimmerDetails style={style} />
                );
            }
            case 'shimmer-group': {
                return (
                    <BVShimmerGroup style={style} />
                );
            }
            case 'shimmer-image': {
                return (
                    <BVShimmerImage style={style} />
                );
            }
            case 'shimmer-nav': {
                return (
                    <BVShimmerNav style={style} />
                );
            }
            case 'shimmer-price': {
                return (
                    <BVShimmerPrice style={style} />
                );
            }
            case 'shimmer-type': {
                return (
                    <BVShimmerType style={style} />
                );
            }
            case 'shimmer-oneline': {
                return (
                    <BVShimmerOneLine style={style} />
                );
            }

            default: {
                return (
                    <span>Loading...</span>
                );
            }
        }
    }

    return (
        <React.Fragment>
            {loading
                ? _handleShimmer()
                : children
            }
        </React.Fragment>
    );
}

export default BVShimmer;